/*
 * Happy Travel SIM — visual discount price display
 *
 * Shows the "discounted" price (configured display %) on product / collection
 * pages for visitors who arrived via the affiliate / marketing discount link.
 *
 * VISUAL ONLY. The real discount is applied by Shopify / GoAffPro at checkout.
 * We intentionally display a smaller % than the real code (under-promise).
 *
 * The discount links are generated by GoAffPro, so detection is multi-signal
 * and activates on ANY of the following (whichever fires first wins, then the
 * state is remembered in localStorage so it persists across pages):
 *
 *   1. localStorage flag   -> set on a previous page this session
 *   2. ?promo=<token>      -> optional manual campaign link (?promo=happy15)
 *   3. discount_code cookie -> Shopify code, if a coupon was auto-applied
 *   4. GoAffPro referral    -> ?ref= param, or a goaffpro cookie / localStorage
 *                              key (covers links like happytravelsim.com/happy15)
 *
 * All of these are configurable from Theme settings → "Happy Travel — Discount
 * display".
 */
(function () {
  var cfg = window.HTDiscount || {};
  var CODE = String(cfg.code || 'HappyTravelSIM').toUpperCase();
  var TOKEN = String(cfg.promoToken || 'happy15').toUpperCase();
  var AFFILIATE = cfg.affiliate !== false; // default on
  var PARAM = cfg.param || 'promo';
  var KEY = 'ht_discount_active';

  function activate() {
    document.documentElement.classList.add('discount-pricing-active');
  }

  function persist() {
    try {
      window.localStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  function params() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return null;
    }
  }

  // Detect any GoAffPro affiliate-referral footprint, without depending on the
  // exact cookie/storage key names (which can change between app versions).
  function hasAffiliateSignal() {
    var p = params();
    if (p && p.get('ref')) return true;
    try {
      if (/goaffpro/i.test(document.cookie)) return true;
    } catch (e) {}
    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var k = window.localStorage.key(i) || '';
        if (k.toLowerCase().indexOf('goaffpro') !== -1) return true;
      }
    } catch (e) {}
    return false;
  }

  var on = false;

  // 1. Already activated in this browser
  try {
    if (window.localStorage.getItem(KEY)) on = true;
  } catch (e) {}

  // 2. ?promo= token (manual campaign links)
  var p = params();
  if (p) {
    var promo = p.get(PARAM);
    if (promo && promo.toUpperCase() === TOKEN) on = true;
  }

  // 3. Shopify discount_code cookie (if a coupon was auto-applied)
  try {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (m && decodeURIComponent(m[1]).toUpperCase().indexOf(CODE) !== -1) on = true;
  } catch (e) {}

  // 4. GoAffPro affiliate referral
  if (AFFILIATE && hasAffiliateSignal()) on = true;

  if (on) {
    persist();
    activate();
  }

  // QA helper: window.HTDiscountClear() turns the discounted display back off.
  window.HTDiscountClear = function () {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {}
    document.documentElement.classList.remove('discount-pricing-active');
  };
})();
